import React, { useContext, useState } from 'react';
import t from 'react-translate';
import { useSelector, useDispatch } from 'react-redux';
import uuid from 'react-uuid';

// redux
import { getFlatCourseAliases } from 'redux/selectors/course';
import {
  createAiLearnerGoal,
  deleteAiLearnerGoal,
  updateAiLearnerGoal,
} from 'redux/actions/ai-role-play';

import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import {
  ReactComponent as AIObjectives,
} from 'styles/icons/ai-objectives.svg';
import { doubleSpacing } from 'styles/global_defaults/scaffolding';
import NvTextArea from 'shared/components/inputs/nv-text-area';
import { useFieldArray, useFormContext } from 'react-hook-form';
import ObjectiveInputList from './objective-input-list';
import EditAiInstructionContext from './context';

const LearnerObjectiveSetting = () => {
  const params = useLecturePageParams();
  const [isAddingNewLearnerGoal, setIsAddingNewLearnerGoal] = useState(false);

  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));
  const {
    control,
    getValues,
    formState: { errors },
  } = useFormContext();
  const { aiRolePlayId } = useContext(EditAiInstructionContext) || {};
  const dispatch = useDispatch();

  const {
    fields,
    append,
    remove,
  } = useFieldArray({
    name: 'aiLearnerGoals',
    control,
    keyName: 'id',
  });

  const handleAddAiLearnerGoal = () => {
    if (aiRolePlayId) {
      setIsAddingNewLearnerGoal(true);
      dispatch(createAiLearnerGoal({
        catalogId: params.catalogId,
        aiRolePlayId,
        text: '',
      })).then((res) => {
        if (res) {
          append({ id: res.payload.id, text: '' });
        }
      }).finally(() => {
        setIsAddingNewLearnerGoal(false);
      });
    } else {
      append({ id: uuid(), text: '' });
    }
  };

  const handleRemoveAiLearnerGoal = (aiLearnerGoalId) => {
    if (fields.length <= 0) return;
    const index = fields.findIndex(field => field.id === aiLearnerGoalId);
    remove(index);
    if (aiRolePlayId && aiLearnerGoalId) {
      dispatch(deleteAiLearnerGoal({
        catalogId: params.catalogId,
        aiRolePlayId,
        aiLearnerGoalId,
      }));
    }
  };

  return (
    <div>
      <div className='d-flex flex-column'>
        <div className='d-flex justify-content-center mt-8'>
          <AIObjectives
            height={doubleSpacing}
            width={doubleSpacing}
          />
        </div>
        <p className='page-title mb-4 mt-2 mx-auto text-black'>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.THE_LEARNER_GOALS(courseAliases)}
        </p>
        <p className='text-align-justify text-large-body lh-25'>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.WRITE_LEARNER_OBJECTIVES(courseAliases)}
        </p>
      </div>
      <NvTextArea
        name='requiredAiLearnerGoal.text'
        withForm
        className='border-gray-5 bg-white required-textarea'
        textareaClassName='min-h-sm text-large-body lh-25'
        required
      />
      <ObjectiveInputList
        name='aiLearnerGoals'
        fields={fields}
        handleAddField={handleAddAiLearnerGoal}
        handleRemoveField={handleRemoveAiLearnerGoal}
        isAddingField={isAddingNewLearnerGoal}
        maxFieldCount={4}
      />
    </div>
  );
};

export default LearnerObjectiveSetting;
